import { call, fork, put, take } from 'redux-saga/effects';
import {
  adminReferralsFailed,
  loadAdminReferrals,
  recordAdminPayment,
  setAdminReferrals,
  updateReferralSettings,
  deleteAdminPayment,
  recordAdminPayout,
  deleteAdminPayout,
} from './reducer';
import apiService from '../../api/apiServices/apiService';
import { toast } from 'react-toastify';

function* watchLoadAdminReferrals() {
  while (true) {
    yield take(loadAdminReferrals.type);

    const { success, reject } = yield call([apiService, apiService.getAdminReferrals]);

    if (success) {
      yield put(setAdminReferrals(success.payload));
    }
    if (reject) {
      yield put(adminReferralsFailed());
      toast.error(reject.payload.message);
    }
  }
}

function* watchRecordAdminPayment() {
  while (true) {
    const { payload }: ReturnType<typeof recordAdminPayment> = yield take(recordAdminPayment.type);

    const { success, reject } = yield call([apiService, apiService.recordReferralPayment], payload);

    if (success) {
      const result = success.payload as {
        commissionAmount?: number;
        referrerId?: number | null;
      };
      if (result.referrerId && result.commissionAmount) {
        toast.success(`Платёж записан. Комиссия: $${Number(result.commissionAmount).toFixed(2)}`);
      } else if (result.referrerId === null) {
        toast.warn('Платёж записан, но реферер не указан — комиссия 0');
      } else {
        toast.success('Платёж записан');
      }
      yield put(loadAdminReferrals());
    }
    if (reject) {
      toast.error(reject.payload.message);
    }
  }
}

function* watchUpdateReferralSettings() {
  while (true) {
    const { payload }: ReturnType<typeof updateReferralSettings> = yield take(
      updateReferralSettings.type,
    );

    const { success, reject } = yield call(
      [apiService, apiService.updateReferralSettings],
      payload,
    );

    if (success) {
      toast.success('Комиссия по умолчанию сохранена');
      yield put(loadAdminReferrals());
    }
    if (reject) {
      toast.error(reject.payload.message);
    }
  }
}

function* watchDeleteAdminPayment() {
  while (true) {
    const { payload }: ReturnType<typeof deleteAdminPayment> = yield take(deleteAdminPayment.type);

    const { success, reject } = yield call([apiService, apiService.deleteReferralPayment], payload);

    if (success) {
      toast.success('Оплата удалена');
      yield put(loadAdminReferrals());
    }
    if (reject) {
      toast.error(reject.payload.message);
    }
  }
}

function* watchRecordAdminPayout() {
  while (true) {
    const { payload }: ReturnType<typeof recordAdminPayout> = yield take(recordAdminPayout.type);

    const { success, reject } = yield call([apiService, apiService.recordReferralPayout], payload);

    if (success) {
      toast.success('Выплата записана');
      yield put(loadAdminReferrals());
    }
    if (reject) {
      toast.error(reject.payload.message);
    }
  }
}

function* watchDeleteAdminPayout() {
  while (true) {
    const { payload }: ReturnType<typeof deleteAdminPayout> = yield take(deleteAdminPayout.type);

    const { success, reject } = yield call([apiService, apiService.deleteReferralPayout], payload);

    if (success) {
      toast.success('Выплата удалена');
      yield put(loadAdminReferrals());
    }
    if (reject) {
      toast.error(reject.payload.message);
    }
  }
}

export default function* adminReferralsSaga() {
  yield fork(watchLoadAdminReferrals);
  yield fork(watchRecordAdminPayment);
  yield fork(watchUpdateReferralSettings);
  yield fork(watchDeleteAdminPayment);
  yield fork(watchRecordAdminPayout);
  yield fork(watchDeleteAdminPayout);
}
